module.exports = "/lucky-balls/img/drum/drum_loop_040.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_040.png
// module id = 1055
// module chunks = 0